//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const home = () => import("../components/home.vue");

const whatsNext = () => import("../components/whatsNext.vue");
const viewone = () => import("../components/viewone.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  {
    name: "home",
    path: "/",
    component: home,
    display: "home",
  },

  {
    name: "viewone",
    path: "/viewone/:id",
    component: viewone,
    display: "viewone",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
